// extracted by mini-css-extract-plugin
module.exports = {"container":"Companies_container__I9PuP","content":"Companies_content__XuLAg","item":"Companies_item__4J5D_","title":"Companies_title__xvNEW"};